"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Videos(_a) {
    var videos = _a.videos, videoParams = _a.videoParams, setVideoParams = _a.setVideoParams, channel = _a.channel;
    var editSelect = function (value, paramValue) {
        var params = __assign(__assign({}, videoParams), { page: 1 });
        value ? params[paramValue] = value : delete params[paramValue];
        setVideoParams(params);
    };
    function lazyload(params) {
        setVideoParams(params, true);
    }
    return react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-channels-videos storybook-layouts-space' },
        react_1.default.createElement("div", { className: 'storybook-channels-videos-menu' },
            react_1.default.createElement("div", null,
                react_1.default.createElement("h3", { className: 'storybook-title-playlist' }, "Playlist"),
                !channel.loading && react_1.default.createElement(storybook_1.Playlists.Dropdown, { route: 'public.playlists', params: { channel_id: channel.id, hidden: 0 }, value: videoParams.category, onChange: function (value) { return editSelect(value, 'category'); } })),
            channel.teams_count > 1 && channel.type.name === 'club' &&
                react_1.default.createElement("div", null,
                    react_1.default.createElement("h3", { className: 'storybook-title-playlist' }, "Teams"),
                    !channel.loading && react_1.default.createElement(storybook_1.Teams.Dropdown, { params: { club_id: channel.id }, value: videoParams.team, onChange: function (value) { return editSelect(value, 'team'); } })),
            react_1.default.createElement(storybook_1.Ads.Ad, { type: 'rectangle-halfpage' })),
        react_1.default.createElement("div", { className: 'storybook-channels-videos-cards' },
            react_1.default.createElement(storybook_1.Videos.Cards, null, videos.data.map(function (video, index) {
                return react_1.default.createElement(storybook_1.Videos.Card, { key: index, video: video });
            })),
            react_1.default.createElement(storybook_1.Lists.Lazyload, { loading: videos.loading, load: videos.meta.current_page !== videos.meta.last_page, onEnter: function () { return lazyload(__assign(__assign({}, videoParams), { page: videos.meta.current_page + 1 })); } })));
}
exports.default = Videos;
